// Auto-generated static 301 redirect map. Edit cautiously.
// Used by NotFoundPage to redirect deleted/legacy URLs before the DB lookup runs.
export const STATIC_REDIRECTS: Record<string, string> = {
  "/accountant-web-design-faq-colorado": "/accountant-web-design-colorado",
  "/acupuncture-web-design-faq-colorado": "/acupuncture-web-design-colorado",
  "/addiction-treatment-web-design-faq-colorado": "/addiction-treatment-web-design-colorado",
  "/allergist-web-design-faq-colorado": "/allergist-web-design-colorado",
  "/audiology-web-design-faq-colorado": "/audiology-web-design-colorado",
  "/bankruptcy-lawyer-web-design-faq-colorado": "/bankruptcy-lawyer-web-design-colorado",
  "/barbershop-web-design-faq-colorado": "/barbershop-web-design-colorado",
  "/basement-finishing-web-design-faq-colorado": "/basement-finishing-web-design-colorado",
  "/bathroom-remodeling-web-design-faq-colorado": "/bathroom-remodeling-web-design-colorado",
  "/business-lawyer-web-design-faq-colorado": "/business-lawyer-web-design-colorado",
  "/cardiology-web-design-faq-colorado": "/cardiology-web-design-colorado",
  "/carpet-cleaning-web-design-faq-colorado": "/carpet-cleaning-web-design-colorado",
  "/catering-web-design-faq-colorado": "/catering-web-design-colorado",
  "/chimney-sweep-web-design-faq-colorado": "/chimney-sweep-web-design-colorado",
  "/cosmetic-surgery-web-design-faq-colorado": "/cosmetic-surgery-web-design-colorado",
  "/cpa-web-design-faq-colorado": "/cpa-web-design-colorado",
  "/custom-home-builder-web-design-faq-colorado": "/custom-home-builder-web-design-colorado",
  "/daycare-web-design-faq-colorado": "/daycare-web-design-colorado",
  "/demolition-web-design-faq-colorado": "/demolition-web-design-colorado",
  "/divorce-lawyer-web-design-faq-colorado": "/divorce-lawyer-web-design-colorado",
  "/drywall-web-design-faq-colorado": "/drywall-web-design-colorado",
  "/dui-lawyer-web-design-faq-colorado": "/dui-lawyer-web-design-colorado",
  "/dumpster-rental-web-design-faq-colorado": "/dumpster-rental-web-design-colorado",
  "/employment-lawyer-web-design-faq-colorado": "/employment-lawyer-web-design-colorado",
  "/endodontist-web-design-faq-colorado": "/endodontist-web-design-colorado",
  "/epoxy-flooring-web-design-faq-colorado": "/epoxy-flooring-web-design-colorado",
  "/event-venue-web-design-faq-colorado": "/event-venue-web-design-colorado",
  "/excavation-web-design-faq-colorado": "/excavation-web-design-colorado",
  "/fertility-clinic-web-design-faq-colorado": "/fertility-clinic-web-design-colorado",
  "/financial-advisor-web-design-faq-colorado": "/financial-advisor-web-design-colorado",
  "/foundation-repair-web-design-faq-colorado": "/foundation-repair-web-design-colorado",
  "/garage-builder-web-design-faq-colorado": "/garage-builder-web-design-colorado",
  "/gym-web-design-faq-colorado": "/gym-web-design-colorado",
  "/hormone-therapy-web-design-faq-colorado": "/hormone-therapy-web-design-colorado",
  "/immigration-lawyer-web-design-faq-colorado": "/immigration-lawyer-web-design-colorado",
  "/insulation-web-design-faq-colorado": "/insulation-web-design-colorado",
  "/insurance-agent-web-design-faq-colorado": "/insurance-agent-web-design-colorado",
  "/ip-lawyer-web-design-faq-colorado": "/ip-lawyer-web-design-colorado",
  "/irrigation-web-design-faq-colorado": "/irrigation-web-design-colorado",
  "/iv-therapy-web-design-faq-colorado": "/iv-therapy-web-design-colorado",
  "/kitchen-remodeling-web-design-faq-colorado": "/kitchen-remodeling-web-design-colorado",
  "/masonry-web-design-faq-colorado": "/masonry-web-design-colorado",
  "/massage-therapy-web-design-faq-colorado": "/massage-therapy-web-design-colorado",
  "/mold-remediation-web-design-faq-colorado": "/mold-remediation-web-design-colorado",
  "/mortgage-broker-web-design-faq-colorado": "/mortgage-broker-web-design-colorado",
  "/ob-gyn-web-design-faq-colorado": "/ob-gyn-web-design-colorado",
  "/oral-surgeon-web-design-faq-colorado": "/oral-surgeon-web-design-colorado",
  "/paving-web-design-faq-colorado": "/paving-web-design-colorado",
  "/pediatric-dentist-web-design-faq-colorado": "/pediatric-dentist-web-design-colorado",
  "/pediatrician-web-design-faq-colorado": "/pediatrician-web-design-colorado",
  "/periodontist-web-design-faq-colorado": "/periodontist-web-design-colorado",
  "/personal-trainer-web-design-faq-colorado": "/personal-trainer-web-design-colorado",
  "/pet-grooming-web-design-faq-colorado": "/pet-grooming-web-design-colorado",
  "/photographer-web-design-faq-colorado": "/photographer-web-design-colorado",
  "/plastic-surgery-web-design-faq-colorado": "/plastic-surgery-web-design-colorado",
  "/podiatry-web-design-faq-colorado": "/podiatry-web-design-colorado",
  "/pole-barn-builder-web-design-faq-colorado": "/pole-barn-builder-web-design-colorado",
  "/primary-care-web-design-faq-colorado": "/primary-care-web-design-colorado",
  "/property-management-web-design-faq-colorado": "/property-management-web-design-colorado",
  "/real-estate-agent-web-design-faq-colorado": "/real-estate-agent-web-design-colorado",
  "/real-estate-lawyer-web-design-faq-colorado": "/real-estate-lawyer-web-design-colorado",
  "/rehab-web-design-faq-colorado": "/rehab-web-design-colorado",
  "/restaurant-web-design-faq-colorado": "/restaurant-web-design-colorado",
  "/salon-web-design-faq-colorado": "/salon-web-design-colorado",
  "/septic-web-design-faq-colorado": "/septic-web-design-colorado",
  "/snow-removal-web-design-faq-colorado": "/snow-removal-web-design-colorado",
  "/tattoo-shop-web-design-faq-colorado": "/tattoo-shop-web-design-colorado",
  "/tax-attorney-web-design-faq-colorado": "/tax-attorney-web-design-colorado",
  "/tutor-web-design-faq-colorado": "/tutor-web-design-colorado",
  "/videographer-web-design-faq-colorado": "/videographer-web-design-colorado",
  "/water-damage-restoration-web-design-faq-colorado": "/water-damage-restoration-web-design-colorado",
  "/wedding-photographer-web-design-faq-colorado": "/wedding-photographer-web-design-colorado",
  "/weight-loss-clinic-web-design-faq-colorado": "/weight-loss-clinic-web-design-colorado",
  "/well-drilling-web-design-faq-colorado": "/well-drilling-web-design-colorado",
  "/workers-comp-lawyer-web-design-faq-colorado": "/workers-comp-lawyer-web-design-colorado",
  "/yoga-studio-web-design-faq-colorado": "/yoga-studio-web-design-colorado",
  "/google-maps-for-hvac-faq": "/local-seo-for-hvac",
  "/google-maps-for-plumbing-faq": "/local-seo",
  "/seo-for-hvac-faq": "/seo-for-hvac",
  "/seo-for-plumbing-faq": "/seo-for-plumbing",
  "/seo-for-roofing-faq": "/seo-for-roofing",
  "/seo-for-law-firms-faq": "/local-seo",
  "/web-design-for-dentists-faq": "/web-design",
  "/ppc-for-personal-injury-attorneys-faq": "/google-ads-ppc",
  "/colorado-springs-seo-faq": "/colorado-springs-seo"
};
